// removed by extract-text-webpack-plugin
module.exports = {"wasabi-searchbox":"wasabi-searchbox","icon":"icon"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Form/SearchBox.scss
// module id = 222
// module chunks = 0